<template>
  <v-form-field v-bind="$props">
    <template v-slot:append>
      <slot name="append"></slot>
    </template>
    <template v-slot:label-prepend>
      <slot name="label-prepend"></slot>
    </template>
    <template v-slot:label-append>
      <slot name="label-append"></slot>
    </template>
    <template v-slot:label>
      <slot name="label"></slot>
    </template>
    <template v-slot:content>
      <v-file-input v-if="!readonly"
                    :loading="$store.getters.loading['FILE_UPLOAD']"
                    :multiple="multiple"
                    class="form-input__border"
                    :accept="accept"
                    style="line-height: 5px;"
                    flat
                    solo
                    :disabled="disable"
                    hide-details dense v-model="files"
                    @change="onchange"
      ></v-file-input>
    </template>
  </v-form-field>
</template>
<script>
import envConfig from '../../config/';

export default {
  name: "FormFileInputField.vue",
  props: {
    small: {
      type: Boolean,
      default: false
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    xxSmall: {
      type: Boolean,
      default: false
    },
    middle: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    xxLarge: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    disable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: null,
    placeholder: {type: String},
    autofocus: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: Number
    },
    fieldWidth: {
      type: Number
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    removeLabel: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 80
    },
    target: {
      type: String
    },
    targetId: {},
    tag: {},
    returnObject: {
      type: Boolean,
      default: true
    },
    returnUuid: {
      type: Boolean,
      default: false
    },
    returnUrl: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    uploadApi: {
      type: String,
      default: "FILE_UPLOAD"
    },
    accept: {
      type: String,
      default: "*"
    }
  },
  data() {
    return {
      files: null,
    }
  },
  methods: {
    onchange(val) {
      if (!this.files || this.files.length == 0) {
        return;
      }
      let formData = new FormData();
      if (this.files instanceof Array) {
        for (let file of this.files) {
          formData.append("files", file, file.name);
        }
      } else {
        formData.append("files", this.files, this.files.name);
      }
      if (this.target) {
        formData.append("target", this.target);
      }
      if (this.targetId) {
        formData.append("targetId", this.targetId);
      }
      if (this.tag) {
        formData.append("tag", this.tag);
      }
      this.$request.request(this.uploadApi, formData).then(response => {
        if (this.returnUrl && !this.multiple) {
          let url = envConfig.baseURL + "/fnd/file/download?docId=" + response.table[0].uuid;
          this.$emit('input', url);
        } else if (this.returnUuid && !this.multiple) {
          this.$emit('input', response.table[0].uuid);
        } else {
          this.$emit("input", response.table);
        }
        response.table.forEach(item => {
          item.url = envConfig.baseURL + "/fnd/file/download?docId=" + item.uuid;
        })
        this.$emit('uploaded', response.table);
      })
    }
  }
}
</script>
